import { render, staticRenderFns } from "./DetailAccountNumber.vue?vue&type=template&id=15d0ef7b"
import script from "./DetailAccountNumber.vue?vue&type=script&lang=js"
export * from "./DetailAccountNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports